import AMLSettingsRoutes from '@/modules/global-settings/aml/routes';
import CompanySettingsRoutes from '@/modules/global-settings/company/routes';
import SecurityRoutes from '@/modules/global-settings/security/routes';
import MiscellaneousRoutes from '@/modules/global-settings/miscellaneous/routes';
import LoanOriginationSettingsRoutes from '@/modules/global-settings/loan-origination/routes';
// import SystemRoutes from '@/modules/global-settings/system/routes';
import OnBoarderRoutes from '@/modules/global-settings/onboarder/routes';
import SharedRoutes from '@/modules/global-settings/shared/routes';
import IntegrationRoutes from '@/modules/integrations/routes';
import DelinquencyRoutes from '@/modules/global-settings/delinquency/routes';
import GeneralLedgerRoutes from '@/modules/global-settings/general-ledger/routes';
import FollowUpActionRoutes from '@/modules/global-settings/follow-up-actions/routes';

export default [
  ...FollowUpActionRoutes,
  ...AMLSettingsRoutes,
  ...CompanySettingsRoutes,
  ...SecurityRoutes,
  ...MiscellaneousRoutes,
  ...LoanOriginationSettingsRoutes,
  // ...SystemRoutes,
  ...OnBoarderRoutes,
  ...IntegrationRoutes,
  ...SharedRoutes,
  ...DelinquencyRoutes,
  ...GeneralLedgerRoutes
];
